import styled from 'styled-components';

import { ExpandableTable } from '@thinknet-gmbh/platform-common-ui';

export const MainContainer = styled.div`
  height: 100%;

  .ant-table-content .ant-table-tbody {
    .ant-table-expanded-row td > div {
      padding: 0;
    }
    .ant-table-row td > div {
      padding: 9px 12px;
    }
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const CompaniesListTable = styled(ExpandableTable)`
  .ant-table-tbody > tr.ant-table-expanded-row > td {
    border-bottom: none;
  }
`;

export const DepartmentsListTable = styled(ExpandableTable)`
  .ant-table-thead {
    background: ${({ theme }) => theme.colors.grayVariations.light};
    & > tr > th {
      padding: 9px 12px;
    }
  }
`;
